import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperclip } from '@fortawesome/pro-solid-svg-icons';

import Button from 'shared/button';
import ManagedInput from 'components/form/managed_input';
import Modal from 'components/modal';
import Row from './row';

export default function AttachmentsModal({
  copyAttachments,
  parentAttachments = [],
  show,
  onClose
}) {
  const [attachments, setAttachments] = useState({});
  const [attachmentsSaving, setAttachmentsSaving] = useState(false);

  const resetAttachments = () => {
    const updatedAttachments = {};
    parentAttachments.forEach(attachment => updatedAttachments[attachment.id] = { ...attachment, selected: false });
    setAttachments(updatedAttachments);
    setAttachmentsSaving(false);
  };

  const handleCopy = async () => {
    setAttachmentsSaving(true);
    await copyAttachments(Object.values(attachments).reduce((ids, attachment) => {
      if (attachment.selected) {
        ids.push(attachment.id);
      }
      return ids;
    }, []));
    onClose();
  };

  const handleSelectedUpdate = (id, selected) => {
    const updatedAttachments = { ...attachments };
    updatedAttachments[id].selected = selected;
    setAttachments(updatedAttachments);
  };

  const handleSelectAll = () => {
    const allSelected = Object.values(attachments).every(attachment => attachment.selected);
    const updatedAttachments = { ...attachments };
    Object.keys(updatedAttachments).forEach(id => updatedAttachments[id].selected = !allSelected);
    setAttachments(updatedAttachments);
  };

  const renderControls = selected => (
    <React.Fragment>
      <Button.Cancel onClick={onClose}/>
      <Button.Primary
        disabled={attachmentsSaving || !selected}
        label={attachmentsSaving ? 'Copying...' : 'Copy Selected'}
        onClick={handleCopy}
      />
    </React.Fragment>
  );

  const numberSelected = Object.values(attachments).filter(attachment => attachment.selected).length;
  return (
    <Modal
      backdrop="static"
      show={show}
      onCancel={onClose}
      onHide={onClose}
      onShow={resetAttachments}
    >
      <Modal.Header closeButton>
        Copy Attachments from Project Deal
      </Modal.Header>

      <Modal.Body>
        <div className="backoffice-attachments-table">
          <table>
            <thead>
              <tr>
                <td className="fixed-width">
                  <ManagedInput
                    checked={numberSelected === Object.keys(attachments).length}
                    indeterminate={
                      numberSelected > 0 &&
                      numberSelected !== Object.keys(attachments).length
                    }
                    name="selected"
                    type="checkbox"
                    onChange={handleSelectAll}
                  />
                </td>
                <td className="fixed-width">
                  <FontAwesomeIcon className="text-muted" icon={faPaperclip} />
                </td>
                <td className="name w-100">
                  Attachment Name
                </td>
              </tr>
            </thead>
            <tbody>
              {Object.keys(attachments).map(id => (
                <Row
                  attachment={attachments[id]}
                  key={id}
                  onSelectedChanged={handleSelectedUpdate}
                />
              ))}
            </tbody>
          </table>
        </div>
      </Modal.Body>

      <Modal.Footer>
        {renderControls(numberSelected)}
      </Modal.Footer>
    </Modal>
  );
}

AttachmentsModal.propTypes = {
  attachmentsSaving: PropTypes.bool,
  copyAttachments: PropTypes.func,
  documentsFolder: PropTypes.object,
  parentAttachments: PropTypes.array,
  show: PropTypes.bool,
  onClose: PropTypes.func
};
